<template>
	<v-slide-group class="smoothScrollContainer">
		<MovePanel class="smoothScrollPanel" v-for="move in moves" :key="move.id" :move="move.move" :customer-move="move" :lite="lite" />
	</v-slide-group>
</template>

<script>
import MovePanel from './MovePanel.vue';

export default {
	name: "MovesWidget",
	props: ['moves', 'lite'],
	components: {MovePanel},
	data() {
		return{
			
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.title-col {
	font-size: 20px;
}

.arrow-col {
	text-align: right;
	padding-left: 0px;
	padding-top: 15px;
}

.arrow {
	width: 18px;
}

.smoothScrollPanel{
	margin-bottom: 10px;

}

</style>